import { registerBeginnerSwitchBlocks as defineSwitchBlocks } from './switch-blocks.js';

let registered = false;

export function registerBeginnerSwitchBlocks(): void {
  if (registered) {
    return;
  }
  defineSwitchBlocks();
  registered = true;
}
